import { Translate } from 'react-redux-i18n'
import { UseI18n } from '../../common/hooks/useI18n'
import { UseTypeFontSize } from '../../common/hooks/useTypeFontSize'
import { Element } from '../../common/html/element'
import { getFontSize } from '../../helpers/fontSize'
import { formatText } from '../../helpers/value'
import { convertAvailableFSData } from '../helper'
import classes from '../index.module.scss'

const DataOnLyFinancialAnalysis = ({ detail, isOrderInformation }) => {
  const typeFontSize = UseTypeFontSize()

  return (
    <div className={classes.itemData}>
      <div className={classes.column1} />
      <div className={classes.column2}>
        <div>
          <div className="dFlex gap1">
            <div className="fw600">
              <Translate value="cartAndOrders.main.availableData" />:
            </div>
            <div>{convertAvailableFSData(detail)}</div>
          </div>
          {!!detail?.years[0] && (
            <div className={classes.pdt8}>
              <Element className="fw600 pb1">
                <Translate value="cartAndOrders.cart.financialSetting" />:
              </Element>
              <div className="pl3">
                <div>
                  <div>{formatText(detail.sourceOrganizationId)}</div>
                  <div className={classes.mt4}>
                    {
                      <Translate
                        value={`cartAndOrders.main.${
                          detail.consolidated
                            ? 'CONSOLIDATED'
                            : 'UNCONSOLIDATED'
                        }`}
                      />
                    }
                  </div>
                  <div
                    style={{
                      width:
                        getFontSize(
                          isOrderInformation ? 250 : 300,
                          typeFontSize,
                        ) * 1.5,
                    }}
                    className={`${classes.mt4} ${classes.fsItemContainer}`}
                  >
                    {!!detail?.yearsFS[0] && (
                      <>
                        {detail.yearsFS
                          .map(
                            (year) =>
                              `${year}: ${UseI18n(
                                `cartAndOrders.main.${
                                  detail.auditStatuses[year]
                                    ? 'AUDITED'
                                    : 'UNAUDITED'
                                }`,
                              )}, ${UseI18n(
                                `cartAndOrders.main.${
                                  detail.methods[year] ? 'DIRECT' : 'INDIRECT'
                                }`,
                              )}`,
                          )
                          .map((val, index) => {
                            const isLeft =
                              index === 1 || index === 2 || index === 4
                            return (
                              <Element
                                key={index}
                                style={{
                                  borderLeft: isLeft
                                    ? '1px solid #D5D5D5'
                                    : undefined,
                                  textAlign: 'left',
                                  padding: isLeft ? '0 10px' : 0,
                                  width: getFontSize(
                                    isOrderInformation ? 125 : 150,
                                    typeFontSize,
                                  ),
                                }}
                                className={`${classes.fsItem} `}
                              >
                                {formatText(val)}
                              </Element>
                            )
                          })}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default DataOnLyFinancialAnalysis
